import { render } from "./TabLicenzaFatturazione.vue?vue&type=template&id=9f54515e&scoped=true"
import script from "./TabLicenzaFatturazione.vue?vue&type=script&lang=js"
export * from "./TabLicenzaFatturazione.vue?vue&type=script&lang=js"

import "./TabLicenzaFatturazione.vue?vue&type=style&index=0&id=9f54515e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f54515e"]])

export default __exports__